import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ElementPage from "../Elements";
import { Container } from "react-bootstrap";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { GalleryAndAlbum } from "./PhotoAndVideoListPage";
import { GalleryNAlbum } from "./GalleryAlbumPage";
import { getAlbumMediaGetListActiveIsHome } from "./MeldiDhamCRUD";
import CategoryListForHome from "./product-category/CategoryListForHome";
import { Link } from "react-router-dom";

const galleryImages = [
  "https://via.placeholder.com/300x200?text=Temple+1",
  "https://via.placeholder.com/300x200?text=Temple+2",
  "https://via.placeholder.com/300x200?text=Temple+3",
  "https://via.placeholder.com/300x200?text=Temple+4",
];

const WhyChoosePage = () => {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = React.useState(true);
  const [galleryImages, setGalleryImages] = React.useState([]);
  const pathUrl = process.env.REACT_APP_API_URL;

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  useEffect(() => {
    setLoading(true);
    fetchGalleryImages();
  }, []);

  const fetchGalleryImages = async () => {
    try {
      const res = await getAlbumMediaGetListActiveIsHome();
      if (res.data.isSuccess) {
        const filteredImages = res.data.responseObject.filter(
          (item) => item.mediaType === "Photo" || item.mediaTypeID === 1,
        );
        setGalleryImages(filteredImages);
        setLoading(false);
      }
    } catch (err) {
      console.error("Album Media fetch error:", err);
      setLoading(false);
    }
  };

  const getLocalized = (item, field) => {
    const lang = i18n.language;
    if (lang === "gu") return item[`${field}_GJ`] || item[field];
    if (lang === "hi") return item[`${field}_HN`] || item[field];
    if (lang === "en") return item[`${field}_EN`] || item[field];
    return item[field];
  };

  // -------------Popup modal logic func---------------------
  const [showAlbum, setShowAlbum] = React.useState(false);
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const [modalItem, setModalItem] = React.useState(null);
  const handleShow_Album = (index) => {
    setCurrentIndex(index);
    setModalItem(galleryImages[index]);
    setShowAlbum(true);
  };

  const handleClose_Album = () => {
    setShowAlbum(false);
    setModalItem(null);
  };

  const handleNext = () => {
    const nextIndex = (currentIndex + 1) % galleryImages.length;
    setCurrentIndex(nextIndex);
    setModalItem(galleryImages[nextIndex]);
  };

  const handlePrev = () => {
    const prevIndex =
      (currentIndex - 1 + galleryImages.length) % galleryImages.length;
    setCurrentIndex(prevIndex);
    setModalItem(galleryImages[prevIndex]);
  };

  // -------------------------------------

  return (
    <>
      <div
        className="container mb-6 px-4 py-4"
        role="navigation"
        aria-label="Breadcrumb"
        // style={{ marginTop: "var(--header-height)" }}
      >
        <div className="d-flex align-items-center gap-2 py-2">
          <Link
            to="/"
            className="site-button"
            style={{ fontSize: "17px", color: "#000000" }}
          >
            {t("menu.home")} &gt;&gt;
          </Link>

          <span className="text-[#4c934c]" style={{ fontSize: "17px" }}>
            {t("whyChooseUs.whyChooseUsTitle")}
          </span>
        </div>
        <h3
          className="mt-1"
          style={{
            // fontWeight: "bold",
            fontSize: "2.3rem",
            textAlign: "center",
            color: "#31572c",
            letterSpacing: "0.1rem",
          }}
        >
          {t("whyChooseUs.whyChooseUsTitle")}
          <div className="w-16 h-1 bg-[#4c934c] mx-auto mt-2" />
        </h3>
      </div>
      {/* <div className="w-full py-2"> */}
      <section className="container">
        <p className="fs-6 text-gray-900 mb-5 justify-content-center">
          {/* <p className="fs-5 fw-bold mb-1">
            <u>{t("whyChooseUs.whyChooseUsTitle")}</u>
          </p> */}
          {/* <br /> */}
          {/* <p className="mb-2">{t("whyChooseUs.p1")}</p> */}

          <p className="fs-5 fw-bold">{t("whyChooseUs.heading1")}</p>
          <p className="mb-2"> {t("whyChooseUs.p1")}</p>

          <p className="fs-5 fw-bold">{t("whyChooseUs.heading2")}</p>
          <p className="mb-2">{t("whyChooseUs.p2")}</p>
          <p className="fs-5 fw-bold">{t("whyChooseUs.heading3")}</p>
          <p className="mb-2">{t("whyChooseUs.p3")}</p>

          <p className="fs-5 fw-bold">{t("whyChooseUs.heading4")}</p>
          <p className="mb-2">{t("whyChooseUs.p4")}</p>

          <p className="fs-5 fw-bold">{t("whyChooseUs.heading5")}</p>
          <p className="mb-2">{t("whyChooseUs.p5")}</p>

          <p className="fs-5 fw-bold">{t("whyChooseUs.heading6")}</p>
          <p className="mb-2">{t("whyChooseUs.p6")}</p>

          <p className="fs-5 fw-bold">{t("whyChooseUs.heading7")}</p>
          <p className="mb-2">{t("whyChooseUs.p7")}</p>
        </p>
      </section>

      {/* ----------------------- DangiTribe ----------------------------- */}
      <section className="container">
        <p className="fs-6 text-gray-900 mb-5 justify-content-center bg-light p-4 rounded">
          <p className="fs-5 fw-bold mb-1">{t("dangiTribe.title")}</p>
          <p className="mb-2">{t("dangiTribe.p1")}</p>
          <p className="fs-5 fw-bold">{t("dangiTribe.heading1")}</p>
          <p className="mb-2"> {t("dangiTribe.p2")}</p>
          <ul className="list-disc pl-5 space-y-1">
            {t("dangiTribe.points", { returnObjects: true }).map(
              (item, index) => (
                <li key={index}>{item}</li>
              ),
            )}
          </ul>
          <p className="mb-2"> {t("dangiTribe.p3")}</p>
          {/* ---------------------------------------------- */}
          <p className="fs-5 fw-bold">{t("natural_farming_wisdom.title")}</p>
          <p className="mb-2">{t("natural_farming_wisdom.description_1")}</p>
          <p className="mb-2">{t("natural_farming_wisdom.description_2")}</p>
          <p className="mb-2">{t("natural_farming_wisdom.description_3")}</p>
          {/* ---------------------------------------------- */}
          <p className="fs-5 fw-bold mb-1">
            {t("culture_festivals_identity.title")}
          </p>
          <p className="mb-2">{t("culture_festivals_identity.intro")}</p>
          <ul className="list-disc pl-5 space-y-1">
            {t("culture_festivals_identity.points", {
              returnObjects: true,
            }).map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
          <p className="mb-2"> {t("culture_festivals_identity.description")}</p>
          {/* ------------------------------------------------------ */}

          <p className="fs-5 fw-bold mb-1">{t("natural_lifestyle.title")}</p>
          <p className="mb-2">{t("natural_lifestyle.description")}</p>
          {/* ------------------------------------------------------ */}
          <p className="fs-5 fw-bold mb-1">
            {t("forest_medicine_mahuda.title")}
          </p>
          <p className="mb-2">{t("forest_medicine_mahuda.description_1")}</p>
          <p className="mb-2">{t("forest_medicine_mahuda.description_2")}</p>
          {/* ------------------------------------------------------- */}
          <p className="fs-5 fw-bold mb-1">
            {t("indigenous_food_culture.title")}
          </p>
          <p className="mb-2">{t("indigenous_food_culture.intro")}</p>
          <ul className="list-disc pl-5 space-y-1">
            {t("indigenous_food_culture.points", {
              returnObjects: true,
            }).map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
          <p className="mb-2"> {t("indigenous_food_culture.closing")}</p>
        </p>
      </section>
      <ElementPage />
    </>
  );
};

export default WhyChoosePage;
